import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import QAModal from "../qa";

import "./index.scss";


export default ({ form }) => {

	const categories = useSelector(({ discover }) => discover.categories);
	const marketplace_verified = useSelector(({ auth }) => auth.shop.marketplace_verified);
	const [modal, showModal] = useState(false);

	return (
		<div className="product-form-main-back pb-0">

			<div>
				<div className="mb-4">
					<h4>Marketplace</h4>
					<div className="mt-3">
						<span className="paylixecommerce-note">
							This area is for product management in Paylix Marketplace © <br/>
							{!marketplace_verified ? <>You will get full access to it only after you get <b>verified</b> status for your store. <Link target="_blank" to="/settings/shop/marketplace">Details.</Link></> : null}
						</span>
					</div>
				</div>
			</div>

			<div>
				<div className="d-flex flex-wrap w-100">
					<label className="paylixecommerce-label" htmlFor="marketplace_category_id">Marketplace Category</label>
					<select className="paylixecommerce-select" id="marketplace_category_id" disabled={marketplace_verified ? "" : "disabled"} value={form.values.marketplace_category_id} onChange={(e) => form.setFieldValue("marketplace_category_id", e.target.value)}>
						<option value="" disabled hidden>Select category...</option>
						{categories.map(({ title, id }) => <option value={id} key={id}>{title}</option>)}
					</select>
				</div>
			</div>

			<div className="mt-3">
				<label className="paylixecommerce-label" htmlFor="marketplace_category_id">Product QA</label>
				<QAModal
					setModal={showModal}
					modal={modal}
				/>
			</div>

		</div>
	)
}